// extracted by mini-css-extract-plugin
export default {"helloParagraph":"business_helloParagraph__uqnCS","textOnImage":"business_textOnImage__P23Zr","boxForImage":"business_boxForImage__OOSPc"};